export default {
  TEMPLATES_MAILS_LIST: "Liste des modèles courriels",
  ADD_TEMPLATE_MAIL: "Ajouter un modèle courriel",
  TEMPLATE_MAIL_ADDED: "Modèle courriel ajouté",
  EDIT_TEMPLATE_MAIL: "Modifier un modèle courriel",
  TEMPLATE_MAIL_UPDATED: "Modèle courriel mise à jour",
  DELETE_THIS_TEMPLATE_MAIL: "Supprimer ce modèle courriel ?",
  TEMPLATE_MAIL_DELETED: "Modèle courriel supprimée",
  TEMPLATE_DETAIL: "Détails du modèle",
  SUBJECT: "Objet",
  TITLE: "Titre",
  FROM: "De",
  REPLY_TO: "Répondre à",
  FROM_EMAIL: "Email de l'envoie",
  FROM_NAME: "Nom de l'envoie",
  REPLY_TO_EMAIL: "Mail de réponse",
  REPLY_TO_NAME: "Nom de réponse",
  TO: "À",
  CC: "Cc",
  BCC: "Cci",
  TYPE: "Type",
  CONTENT: "Contenu",
  VIEW_TEMPLATE_MAIL: "Modèle courriel",
  COMMUNICATION: "Communication",
  LOGO: "Logo",
  BACKGROUND_COLOR: "Couleur du fond",
  SECTION: "Section",
  FONT_SIZE: "Taille du texte",
  FONT_FAMILY: "Polices",
  TITLE_COLOR: "Couleur du titre",
  TEXT_COLOR: "Couleur du texte",
  LINKS_COLOR: "Couleur des liens",
  BUTTONS_COLOR: "Couleurs des boutons",
  PERSONNALISATION: "Personnalisation",
  MAIL_CONTENT: "Contenu mail",
  IMPORT_LOGO: "Importer un logo",
  ADD_PICTURE: "Ajouter une photo",
  IS_DEFAULT_TEMPLATE: "Modèle par défaut",
  FOOTER_COLOR: "Couleur pied de page",
  CLONE: "Cloner",
  CLONE_THIS_TEMPLATE_MAIL: "Cloner ce modèle courriel ?",
  TEMPLATE_MAIL_CLONED: "Modèle courriel cloné",
  HTML_CONTENT: "Contenu HTML",
  AVAILABLE_VARIABLES: "Variables disponibles",
  SOURCE_CODE: "Code source",
  EMAIL_BUILDER: "Constructeur d'email",
  GENERAL_INFO: "Informations g\u00e9n\u00e9rales",
  SENDER_RECIPIENTS: "Exp\u00e9diteur / Destinataires",
  EDIT_LANGUAGE: "Langue d'\u00e9dition",
  VARIABLES_HINT: "Cliquez sur une variable pour l'ins\u00e9rer dans l'\u00e9diteur.",
};
